import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import snackbar from './snackbar';
import bookings from './bookings';
import airports from './airports';
import countries from './countries';
import regions from './regions';
import trails from './trails';
import bikeTrails from './bikeTrails';
import trips from './trips';
import tourbook from './tourbook';
import services from './services';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    snackbar,
    bookings,
    airports,
    countries,
    regions,
    trails,
    bikeTrails,
    trips,
    tourbook,
    services,
  }
})
